import { useEffect } from 'react'

type ClickAwayProps = {
  isOpened: boolean
  overlay: any
  callback: () => void
}

export function useOnClickAwayOverlay(props: ClickAwayProps) {
  const handleClickOutside = (e: MouseEvent | TouchEvent) => {
    if (
      props.overlay?.current &&
      props.overlay?.current?.contains(e.target as HTMLElement) &&
      e.isTrusted
    ) {
      props.callback()
    }
  }

  useEffect(() => {
    if (props.isOpened) {
      document.addEventListener('mousedown', handleClickOutside)
      document.addEventListener('touchstart', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('touchstart', handleClickOutside)
    }
  }, [props.isOpened])
}
